import { fetchWithSession } from "lib/util/fetchWithSession.js"
/**
 * This is the base service class that all other services should extend from.
 * It provides a common interface for all services.
 * Note: This class will not work outside of the browser. 
 */

/**
 * @class BaseService
 */
class BaseService {
    static apiUrl = "";

    /**
 * @constructor 
 * @param {string} path - The path to the service.
 * @throws {Error} - Throws an error if localStorage is not defined.
 * @memberof BaseService
 */
    constructor(path) {
        try {
            if (typeof localStorage === "undefined") {
                throw new Error("localStorage is not defined. This class will not work outside of the browser.");
            }
        } catch (e) {
            throw new Error("localStorage is not defined. This class will not work outside of the browser.");
        }
        this.path = path;
        this.apiUrl = `/api/${this.path}/`;
    }

    /**
     * @param {string} location - The location of the api endpoint.
     * @param {object} [options] - The options to pass to the fetch request.
     * @returns {Promise<unknown>} - A promise that resolves with the data from the api.
     * @memberof BaseService
     */
    api(location, options) {
        return new Promise((resolve, reject) => {
            const url = `${this.apiUrl}${location}`;
            fetchWithSession(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                },
                ...options
            })
                .then(response => {
                    if (response.ok) {
                        return response.json();
                    }
                    throw new Error(response.statusText);
                })
                .then(data => {
                    resolve(data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
}


export default BaseService;
